import React from 'react';
import LoadingCircle from '../../assets/loading_circle.js';

const ButtonSubmit = ({
  blok,
  isSubmitting,
  padding = 'p-0',
  color = 'yellow',
  parentColor = 'yellow',
}) => {
  // Tailwind CSS classes --- --- --- --- --->

  const buttonStyle =
    'rounded-full border border-transparent transition-border duration-300 ease-in-out text-base font-crystalCondensed relative';

  //change button colors based on background color to ensure contrast
  const buttonBgColors = {
    yellow: 'bg-yellow-60',
    white: 'bg-yellow-60',
    'yellow-secondary': 'bg-yellow-60',
    'yellow-announcement': 'bg-yellow-40',
    blue: 'bg-blue-60',
    'blue-secondary': 'bg-blue-60',
    'blue-announcement': 'bg-blue-60',
    green: 'bg-green-60',
    'green-secondary': 'bg-green-60',
    'green-announcement': 'bg-green-40',
    orange: 'bg-orange-60',
    'orange-secondary': 'bg-orange-60',
    'orange-announcement': 'bg-orange-40',
    black: 'bg-black text-white',
    'button-orange-announcement': 'bg-orange text-white',
  };

  const buttonBgColor =
    buttonBgColors[
      color !== 'yellow' ? `button-${color}` : parentColor || 'yellow'
    ];

  const buttonHoverColors = {
    yellow: 'group-hover:bg-yellow-40',
    white: 'group-hover:bg-yellow-40',
    'yellow-announcement': 'bg-yellow-30',
    blue: 'group-hover:bg-blue-40',
    'blue-announcement': 'bg-blue-30',
    green: 'group-hover:bg-green-40',
    'green-announcement': 'bg-green-30',
    orange: 'group-hover:bg-orange-40',
    'orange-announcement': 'bg-orange-30',
    black: 'group-hover:bg-black',
    'button-orange-announcement': '',
  };

  const buttonHoverColor =
    buttonHoverColors[
      color !== 'yellow' ? `button-${color}` : parentColor || 'yellow'
    ];

  // >--- --- --- --- --- Tailwind CSS classes
  /* 
  const loadingIconColors = {
    redBtnWhiteTxt: '#FFFFFF',
    greenBtnWhiteTxt: '#FFFFFF',
    yellowBtnBlackTxt: '#000000',
    whiteBtnBlackTxt: '#000000',
  }; */

  const buttonTextJSX = (
    <>
      {isSubmitting ? (
        <div className="w-6">
          <LoadingCircle
            tailwindClasses="animate-spin w-full h-full"
            /*             color={loadingIconColors[blok.buttonStyle.style]}
             */
          />
        </div>
      ) : (
        <>
          <span
            className={`${buttonBgColor} ${buttonHoverColor} px-5 py-2 ${buttonStyle}`}
          >
            {blok.label}
          </span>
        </>
      )}
    </>
  );

  return (
    <button
      type="submit"
      className={`rounded-full ${buttonBgColor} hover:bg-transparent no-underline relative flex items-stretch align-center group ${padding} transition-all w-max ${buttonHoverColor} `}
      disabled={isSubmitting}
    >
      {buttonTextJSX}
    </button>
  );
};

export default ButtonSubmit;
